// extracted by mini-css-extract-plugin
export var quoteAuthor = "quote-module--quoteAuthor--ce302";
export var quoteBlock = "quote-module--quoteBlock--0d021";
export var quoteContent = "quote-module--quoteContent--51f7f";
export var quoteDate = "quote-module--quoteDate--70e66";